<template>
    <layout-base>
        <div class="text-center bg full-screen">
            <form class="form-signin">
                <div class="text-center mb-4">
                    <br>

                    <img class="mb-4" alt="Vue logo" src="../../assets/logo-cambialefacile_200-36.png"  >
                    <h1 class="h3 mb-3 font-weight-normal">Registrazione Attivata! </h1>
                    <p>Complimenti la tua registrazione è attivata.  </p>
                </div>
                <a  href="/login"  class="btn btn-lg btn-success btn-block" >Accedi</a>
                <p class="mt-5 mb-3 text-muted text-center"> all &copy; cambialefacile 2015-2019 </p>
            </form>
        </div>
    </layout-base>
</template>



<script>
  export default {
    name: "RegisterConfirmed" //this is the name of the component
  };
</script>

<style scoped>
    .bg{
        background-color: #272F44;
        background-color: #222939;
        color: white;
        min-height: 100vh !important;
    }



    .form-signin {
        width: 100%;
        max-width: 330px;
        padding: 15px;
        margin: 0 auto;
    }
    .form-signin .checkbox {
        font-weight: 400;
    }
    .form-signin .form-control {
        position: relative;
        box-sizing: border-box;
        height: auto;
        padding: 10px;
        font-size: 16px;
    }
    .form-signin .form-control:focus {
        z-index: 2;
    }
    .form-signin input[type="email"] {
        margin-bottom: -1px;
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
    }
    .form-signin input[type="password"] {
        margin-bottom: 10px;
        border-top-left-radius: 0;
        border-top-right-radius: 0;
    }

</style>
